import { Component, Input, OnInit } from '@angular/core';
import { Organization } from "../../../../model/organization";
import { Asset } from "../../../../model/asset";
import { AssetFilters } from "../../../../model/filters/asset-filters";
import { AssetsService } from "../../../../services/assets.service";
import { SortOrder } from "../../../../model/sort-order";
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-organization-assets',
  templateUrl: './organization-assets.component.html',
  styleUrls: ['./organization-assets.component.scss']
})
export class OrganizationAssetsComponent implements OnInit {

  @Input()
  public organization: Organization;

  public assets: Asset[];
  public totalAssets: number;
  public loadingAssets: boolean;

  public rows = 10;
  public first = 0;

  public currentFilters: AssetFilters;

  constructor(private assetsService: AssetsService) {
    this.currentFilters = new AssetFilters();
  }

  ngOnInit(): void {
    this.currentFilters.organizationUuids = [this.organization.uuid];
    this.loadAssets(0, 10);
  }

  private loadAssets(offset: number, limit: number) {
    this.loadingAssets = true;
    this.assetsService.getAssets(offset, limit, this.currentFilters)
      .pipe(finalize(() => this.loadingAssets = false))
      .subscribe(response => {
      this.assets = response.assets;
      this.totalAssets = response.totalElements;
    });
  }

  onPageChange(event: any) {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadAssets(event.first/event.rows, event.rows);
  }

}
